import React, { useState, useEffect } from 'react';
import { TextField } from '@fluentui/react';
import { Color, specialCharacters, ctrlCommandKeys } from '../../const/Const';
import { MessageConst, MessageConstEn } from '../../const/MessageConst';
import { Shimmer } from '@fluentui/react';
import { validEnglish, validNumber, validMongolian, validRegister } from '../../const/Regex';

const FieldText = (props) => {

    const [value, setValue] = useState();
    const [regexMessage, setRegexMessage] = useState("");
    const [warningMsg, setWarningMsg] = useState("");

    const onChanged = (p_value) => {
        if (props.limit > 0 && p_value?.target?.value?.length > props.limit) {
            let tValue = p_value.target.value?.substring(0, props.limit);
            setValue(tValue);
            props.onChanged(tValue, '', props.keyfield, '', props.title);
        } else {
            if (props.regex) {
                if (props.regex === 'register' || props.regex === 'property' || props.regex === 'transport') {
                    setValue(p_value.target.value.toUpperCase());
                }
                onValidate(p_value.target.value);
            } else {
                setValue(p_value.target.value);
            }
            props.onChanged(p_value.target.value, '', props.keyfield, '', props.title);
        }
        if (props.limitMin > 0 && p_value?.target?.value?.length < props.limitMin) {
            setWarningMsg(`Хамгийн багадаа ${props.limitMin} тэмдэгт оруулна уу!`);
        } else {
            setWarningMsg('');
        }
    }

    const onValidate = (p_value) => {
        if (props.regex && p_value) {
            switch (props.regex) {
                case "cyrillic":
                    if (validEnglish.test(p_value)) {
                        setRegexMessage("Кирилл үсэг оруулна уу");
                        return false;
                    } else {
                        setRegexMessage("");
                    }
                    break;
                case "register":
                    const validRegister = /^[А-ЯӨҮЁ]{2}[0-9]{8}$/;
                    if (!validRegister.test(p_value)) {
                        setRegexMessage("Зөв РД оруулна уу");
                    } else {
                        setRegexMessage("");
                    }
                    if (!value || value.length < 2) {
                        if (!validMongolian.test(p_value)) {
                            return false;
                        }
                    } else {
                        if (value && value.length < 10) {
                            if (value.length === 9) {
                                return true;
                            }
                            if (!validNumber.test(p_value)) {
                                return false
                            }
                        } else {
                            setRegexMessage("");
                            return false;
                        }
                    }
                    break;
                case "property":
                    const validPropertyLetter = /^[үҮ]{1}/;
                    const validProperty = /^[Ү]{1}[0-9]{10}$/;
                    if (!validProperty.test(p_value)) {
                        setRegexMessage("Зөв гэрчилгээний дугаар оруулна уу");
                    } else {
                        setRegexMessage("");
                    }
                    if (!value || value.length < 1) {
                        if (!validPropertyLetter.test(p_value)) {
                            return false;
                        }
                    } else {
                        if (value && value.length < 11) {
                            if (value.length === 10) {
                                return true;
                            }
                            if (!validNumber.test(p_value)) {
                                return false
                            }
                        } else {
                            setRegexMessage("");
                            return false;
                        }
                    }
                    break;
                case "transport":
                    const validTransport = /^[0-9]{4}[А-ЯӨҮЁа-яөүёа]{3}$/;
                    const validTransportLetter = /^[А-ЯӨҮЁа-яөүё]$/;
                    if (!validTransport.test(p_value)) {
                        setRegexMessage("Зөв улсын дугаар оруулна уу");
                    } else {
                        setRegexMessage("");
                    }
                    if (!value || value.length < 4) {
                        if (!validNumber.test(p_value)) {
                            return false
                        }
                    } else {
                        if (value && value.length < 7) {
                            if (!validTransportLetter.test(p_value)) {
                                return false;
                            }
                        } else {
                            setRegexMessage("");
                            return false;
                        }
                    }
                    break;
                default:
                    const exp = new RegExp(props.regex);
                    if (!exp.test(p_value)) {
                        setRegexMessage(props.regexMessage);
                        return false;
                    } else {
                        setRegexMessage("");
                    }
                    break;
            }
        }
        return true;
    }

    const onKeyDown = (e) => {
        if (e.keyCode == 13 && props.onEnterClicked) {
            props.onEnterClicked(value);
        }
        if (props.regex && 
            (props.regex === 'cyrillic' || props.regex === 'register' || props.regex === 'property' || props.regex === 'transport')
        ) {
            if (e.ctrlKey && ctrlCommandKeys.includes(e.keyCode)) return;
            if (!specialCharacters.includes(e.keyCode)) {
                let isValid = onValidate(e.key);
                if (!isValid) e.preventDefault();
            }
        }
    }

    const onBlur = () => {
        if (props.onFocusOut) {
            props.onFocusOut();
        }
    }

    useEffect(() => {
        setValue(props.defaultValue);
    }, [props.defaultValue]);

    let vColor = { fontWeight: 600 };
    if (props.gray) {
        vColor = {
            color: Color.graySecond,
            fontWeight: 400
        };
    }

    let vMaxLength = {};
    if (props.maxLength) {
        vMaxLength = {
            maxLength: props.maxLength
        }
    }


    let errorMessage = null;

    if (props.required && props.checkreq) {
        if (props.message) {
            errorMessage = props.message;
        } else if (!value) {
            errorMessage = props.title + (props.lang == "en" ? MessageConstEn.fieldRequired : MessageConst.fieldRequired);
        }
    }

    let styles = {};
    if (props.height) {
        styles = {
            field: {
                height: props.height
            },
            fieldGroup: {
                height: props.height
            }
        }
    }

    return (
        <div>
            {props.title && (
                <div style={{ display: 'flex' }}>
                    <div style={{ fontSize: 14, ...vColor }}>{props.title}</div>{props.required && (<div style={{ color: Color.red }}>*</div>)}
                </div>
            )}
            <div style={{ marginTop: props.title ? 6 : 0 }}>
                {props.loading ? (
                    <div>
                        <Shimmer />
                        <Shimmer />
                    </div>
                ) : (
                    <TextField
                        styles={{ ...styles }}
                        {...vMaxLength}
                        autoComplete='off'
                        disabled={props.disable == true ? true : false}
                        onChange={onChanged}
                        type={props.type}
                        onKeyDown={onKeyDown}
                        value={value}
                        errorMessage={errorMessage}
                        placeholder={props.placeholder}
                        onBlur={onBlur}
                    />
                )}
            </div>
            {props.regex && regexMessage ? (
                <div style={{ color: 'rgb(164, 38, 44)', fontSize: 12, fontWeight: 400, paddingTop: 5 }}>
                    {regexMessage}
                </div>
            ) : null}
            {props.limitMin && warningMsg ? (
                <div style={{ color: 'rgb(164, 38, 44)', fontSize: 12, fontWeight: 400, paddingTop: 5 }}>
                    {warningMsg}
                </div>
            ) : null}
            {props.link ? (
                <div onClick={props.linkfunc} style={{ marginTop: 6, color: Color.blue, cursor: 'pointer', textDecoration: 'underline', fontSize: 12 }}>
                    {props.link}
                </div>
            ) : null}
        </div >
    );
}

export default FieldText;